export default __webpack_public_path__ + "static/media/Flag_of_Brazil.dcc02bb7.svg";